import styled from 'styled-components'

const StyledPageHeader = styled.div`
  background: ${(props => props.theme.colors, 'white')};

  padding: 30px;
  margin-bottom: 8px;
  position: relative;

  h1 {
    margin: 1em 0;

    &:only-child {
      text-align: center;
    }
  }

  ${props => props.theme.media.md`
    padding: 36px 30px 36px;
    text-align: center;
  `}
`

export default StyledPageHeader;
